export const CALENDAR_VIEW_OPTIONS = {
  day: 'day',
  week: 'week',
  month: 'month',
};
